import React from "react";
import { MatchCard } from "./MatchCard";
import { Pagination } from "../common/Pagination";
import "../../styles/matches-list.css";
import { Spinner } from "../common/Spinner";

/**
 * Component to display a list of matches with pagination
 * @param {Object} props - Component props
 * @param {Array} props.matches - Array of match objects
 * @param {Object} props.pagination - Pagination metadata
 * @param {Function} props.onPageChange - Function to handle page changes
 * @param {boolean} props.isLoading - Loading state
 * @param {Object} props.error - Error object if request failed
 * @returns {JSX.Element} - Matches list component
 */
export const MatchesList = ({ 
  matches = [], 
  pagination, 
  onPageChange,
  isLoading, 
  error 
}) => {
  if (isLoading) {
    return (
      <div className="matches-loading">
        <div className="loader">
            <Spinner />
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="matches-error">
        <div className="error-message">
          Failed to load matches. Please try again.
        </div>
      </div>
    );
  }

  if (matches.length === 0) {
    return (
      <div className="matches-empty">
        <div className="empty-message">
          No matches found. Try adjusting your filters.
        </div>
      </div>
    );
  }

  return (
    <div className="matches-list-container">
      <div className="matches-list">
        {matches.map(match => (
          <MatchCard key={match._id} match={match} />
        ))}
      </div>
      
      {pagination && (
        <Pagination
          currentPage={pagination.currentPage}
          totalPages={pagination.totalPages}
          hasPrevPage={pagination.hasPrevPage}
          hasNextPage={pagination.hasNextPage}
          onPageChange={onPageChange}
        />
      )}
    </div>
  );
};
